import {unamount} from "@/modules/humanize";

export default unamount;
